import React, { useMemo, useState } from 'react';

const perfiles = {
  taller: {
    nombre: 'Taller mecánico',
    logo: '🔧',
    tagline: 'Más control de clientes, citas y trabajo sin perder tiempo.',
    headline: 'El taller que se gestiona sin caos',
    descripcion: 'Los talleres pierden horas cada semana en llamadas, seguimiento de citas, control de vehículos, presupuestos y tareas repetitivas. Trix centraliza la operación para que puedas trabajar más rápido, con mejor atención y menos errores.',
    problemas: [
      'Citas y reparaciones sin control claro.',
      'Presupuestos y facturas dispersos.',
      'Falta de seguimiento de clientes y vehículos.',
      'Tareas y equipo sin coordinación real.',
    ],
    soluciones: [
      'Agenda y gestión de citas ITV y servicios.',
      'Presupuestos, pedidos y facturación centralizados.',
      'Stock y herramientas bajo control con alertas inteligentes.',
      'Equipo, fichajes y tareas sincronizados.',
      'Comunicados y campañas por email con historial y reintentos.',
    ],
    beneficios: [
      'Menos tiempo en administración.',
      'Más clientes atendidos por día.',
      'Mejor control del taller y la rentabilidad.',
    ],
    metricas: [
      { valor: '−40%', texto: 'tiempo perdido en gestión' },
      { valor: '2x', texto: 'más productividad por operario' },
      { valor: '24/7', texto: 'visibilidad de la operación' },
    ],
    modulos: ['Clientes', 'Citas', 'ITV', 'Presupuestos', 'Almacén', 'Fichajes', 'Equipo', 'Comunicados', 'Alertas Slack'],
  },
  reforma: {
    nombre: 'Reformas / albañilería',
    logo: '🏗️',
    tagline: 'Control real de obra, costes y tiempos.',
    headline: 'Más control de cada obra y menos pérdidas',
    descripcion: 'En reformas y obra, la pérdida de control suele venir de la falta de seguimiento real: fechas, avances, materiales, costes, facturación y coordinación de equipo. Trix ayuda a convertir cada obra en una operación gestionada y rentable.',
    problemas: [
      'Obras sin control real de avances.',
      'Costes difíciles de seguir y comparar.',
      'Presupuestos y facturas desordenados.',
      'Coordinación de personal y materiales complicada.',
    ],
    soluciones: [
      'Seguimiento de proyectos y avance de obra.',
      'Coste real por obra y rentabilidad.',
      'Certificaciones y facturación por etapa.',
      'Control de materiales, tareas y personal.',
      'Alertas de stock y comunicados automáticos para clientes y proveedores.',
    ],
    beneficios: [
      'Menos pérdidas por falta de control.',
      'Más previsión de recursos y coste.',
      'Mejor gestión de cada obra y cliente.',
    ],
    metricas: [
      { valor: '−30%', texto: 'de pérdidas por descontrol operativo' },
      { valor: '1 vista', texto: 'de todas las obras' },
      { valor: '100%', texto: 'control de costes y progreso' },
    ],
    modulos: ['Clientes', 'Proyectos', 'Tareas', 'Presupuestos', 'Almacén', 'Fichajes', 'Facturación', 'Comunicados', 'Alertas stock'],
  },
  electricista: {
    nombre: 'Pymes electricistas',
    logo: '⚡',
    tagline: 'Más instalaciones terminadas y menos caos de avisos, material y facturas.',
    headline: 'La gestión fácil para empresas electricistas',
    descripcion: 'En una pyme de electricistas es fácil perder tiempo entre llamadas, urgencias, partes, material y facturación. Trix lo simplifica todo para que el equipo sepa qué hacer, cuándo hacerlo y qué falta para terminar cada trabajo.',
    problemas: [
      'Avisos y trabajos urgentes sin orden claro.',
      'Partes y tareas repartidas en WhatsApp o papel.',
      'Material sin control y compras de última hora.',
      'Facturas y cobros retrasados.',
    ],
    soluciones: [
      'Agenda de avisos e instalaciones con seguimiento del estado.',
      'Asignación de tareas por técnico con control de rendimiento.',
      'Stock de material eléctrico con alertas inteligentes por mínimo.',
      'Presupuestos y facturación centralizados en un mismo flujo.',
      'Comunicados a clientes para recordatorios, avisos y seguimiento.',
    ],
    beneficios: [
      'Menos llamadas y menos desorden diario.',
      'Más trabajos cerrados por semana.',
      'Mejor control de costes, material y equipo.',
    ],
    metricas: [
      { valor: '−35%', texto: 'tiempo perdido en coordinación manual' },
      { valor: '+25%', texto: 'trabajos finalizados por técnico' },
      { valor: '24/7', texto: 'visión de avisos, equipo y stock' },
    ],
    modulos: ['Clientes', 'Citas', 'Proyectos', 'Tareas', 'Almacén', 'Presupuestos', 'Fichajes', 'Comunicados', 'Alertas Slack'],
  },
  restaurante: {
    nombre: 'Restaurante',
    logo: '🍽️',
    tagline: 'Servicio más rápido, mejor control y menos caos.',
    headline: 'Un restaurante más ágil y más rentable',
    descripcion: 'Los restaurantes sufren por la coordinación entre mesas, pedidos, stock, personal y servicio. Trix unifica estas tareas en una sola solución, con QR, control de comandas, monitor de cocina y visibilidad del negocio en tiempo real.',
    problemas: [
      'Pedidos y servicio sin control claro.',
      'Stock y aprovisionamiento fuera de control.',
      'Falta de coordinación entre personal y mesa.',
      'Cobros y facturación poco visuales.',
    ],
    soluciones: [
      'Pedidos desde QR y seguimiento en directo.',
      'Control de mesas, comandas y estado del servicio.',
      'Alertas de stock y faltantes.',
      'Resumen del negocio con pagos y facturación.',
      'Comunicados por campaña, promociones y avisos de servicio con historial y filtros.',
    ],
    beneficios: [
      'Más rapidez en el servicio.',
      'Menos errores de pedido y gestión.',
      'Mejor experiencia para clientes y equipo.',
    ],
    metricas: [
      { valor: '−50%', texto: 'tiempo de gestión manual' },
      { valor: '1 canal', texto: 'para pedidos, mesa y pago' },
      { valor: '24/7', texto: 'visibilidad del negocio' },
    ],
    modulos: ['Restaurante', 'QR de mesa', 'Reservas', 'Almacén', 'Facturación', 'Slack alerts', 'Comunicados', 'Campañas'],
  },
  general: {
    nombre: 'Empresa / negocio general',
    logo: '🏢',
    tagline: 'Un único punto de control para toda la operación.',
    headline: 'Tu negocio bajo una sola visión',
    descripcion: 'Muchas empresas crecen sin orden: cada área sigue en su propio Excel, WhatsApp o agenda. Trix elimina ese caos y te da una operación centralizada donde todo está claro, accesible y gestionable.',
    problemas: [
      'Información repartida en varios canales.',
      'Pérdida de tiempo en tareas manuales.',
      'No hay visibilidad real del negocio.',
      'Dificultad para crecer sin aumentar el caos.',
    ],
    soluciones: [
      'Clientes, tareas, agenda y ventas centralizadas.',
      'Visión global de operación y procesos.',
      'Automatización y alertas por eventos.',
      'Escalabilidad sin perder control.',
      'Comunicados masivos segmentados con control de campañas y historial.',
    ],
    beneficios: [
      'Más control del negocio.',
      'Más productividad y mejor decisión.',
      'Menos errores y más capacidad de crecimiento.',
    ],
    metricas: [
      { valor: '−35%', texto: 'tiempo de gestión diaria' },
      { valor: '1 vista', texto: 'de toda la operación' },
      { valor: '100%', texto: 'control remotamente' },
    ],
    modulos: ['Clientes', 'Agenda', 'Tareas', 'Presupuestos', 'Equipo', 'Facturación', 'Dashboard', 'Comunicados', 'Alertas'],
  },
};

const tipos = Object.entries(perfiles);

export default function PropuestaComercial() {
  const [tipo, setTipo] = useState('taller');
  const perfil = useMemo(() => perfiles[tipo], [tipo]);

  return (
    <>
      <style>{`
        .trix-page {
          min-height: 100vh;
          background:
            radial-gradient(circle at 10% 10%, rgba(59, 130, 246, 0.12), transparent 18%),
            radial-gradient(circle at 90% 15%, rgba(14, 165, 164, 0.10), transparent 20%),
            radial-gradient(circle at 50% 100%, rgba(37, 99, 235, 0.08), transparent 25%),
            linear-gradient(180deg, #ffffff 0%, #f4f8ff 40%, #eef5ff 100%);
          color: #0f172a;
          font-family: Inter, Arial, sans-serif;
        }

        .trix-shell {
          max-width: 1200px;
          margin: 0 auto;
          padding: 40px 20px 80px;
        }

        .trix-hero {
          background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 44%, #0ea5a4 100%);
          border-radius: 30px;
          padding: 32px 28px 36px;
          color: white;
          box-shadow: 0 30px 70px rgba(15, 23, 42, 0.18);
          position: relative;
          overflow: hidden;
        }

        .trix-hero::before {
          content: '';
          position: absolute;
          inset: -20% auto auto 55%;
          width: 380px;
          height: 380px;
          background: rgba(255, 255, 255, 0.10);
          border-radius: 50%;
          filter: blur(10px);
        }

        .trix-topbar {
          position: relative;
          z-index: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          flex-wrap: wrap;
          margin-bottom: 26px;
        }

        .trix-brand {
          font-size: 30px;
          font-weight: 900;
          letter-spacing: 1.4px;
        }

        .trix-cta-row {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .trix-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 13px 20px;
          border-radius: 12px;
          text-decoration: none;
          font-weight: 800;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .trix-btn:hover {
          transform: translateY(-1px);
        }

        .trix-btn--primary {
          background: #fff;
          color: #1d4ed8;
          box-shadow: 0 10px 24px rgba(255, 255, 255, 0.18);
        }

        .trix-btn--secondary {
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255, 255, 255, 0.25);
          color: #fff;
        }

        .trix-intro-grid {
          position: relative;
          z-index: 1;
          display: grid;
          grid-template-columns: 1.25fr 0.75fr;
          gap: 28px;
          align-items: center;
        }

        .trix-kicker {
          display: inline-block;
          background: rgba(255, 255, 255, 0.10);
          border: 1px solid rgba(255, 255, 255, 0.18);
          padding: 8px 14px;
          border-radius: 999px;
          font-size: 12px;
          letter-spacing: 1.4px;
          text-transform: uppercase;
          font-weight: 800;
          margin-bottom: 18px;
        }

        .trix-hero h1 {
          margin: 0 0 14px;
          font-size: clamp(2.8rem, 5vw, 5rem);
          line-height: 1.04;
          letter-spacing: -0.06em;
        }

        .trix-hero p {
          margin: 0;
          font-size: 1.25rem;
          line-height: 1.7;
          max-width: 710px;
          color: rgba(255,255,255,0.90);
        }

        .trix-select-wrap {
          margin-top: 26px;
          max-width: 420px;
        }

        .trix-field-label {
          display: block;
          margin-bottom: 8px;
          font-size: 12px;
          letter-spacing: 1.4px;
          text-transform: uppercase;
          color: rgba(255,255,255,0.78);
          font-weight: 800;
        }

        .trix-select {
          width: 100%;
          background: rgba(15, 23, 42, 0.28);
          border: 1px solid rgba(255,255,255,0.22);
          border-radius: 12px;
          color: white;
          padding: 14px 16px;
          font-size: 1rem;
          font-weight: 700;
          outline: none;
          appearance: none;
          background-image: linear-gradient(45deg, transparent 50%, rgba(255,255,255,0.8) 50%), linear-gradient(135deg, rgba(255,255,255,0.8) 50%, transparent 50%);
          background-position: calc(100% - 20px) calc(50% - 2px), calc(100% - 14px) calc(50% - 2px);
          background-size: 6px 6px, 6px 6px;
          background-repeat: no-repeat;
        }

        .trix-select option {
          color: #0f172a;
        }

        .trix-hero-actions {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          margin-top: 20px;
        }

        .trix-panel {
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid rgba(255,255,255,0.14);
          border-radius: 22px;
          padding: 22px;
          backdrop-filter: blur(8px);
        }

        .trix-panel-kicker {
          font-size: 12px;
          letter-spacing: 2px;
          text-transform: uppercase;
          opacity: 0.8;
          margin-bottom: 12px;
          font-weight: 800;
        }

        .trix-sector-name {
          font-size: 1.8rem;
          font-weight: 900;
          margin-bottom: 10px;
        }

        .trix-tagline {
          font-size: 1.05rem;
          line-height: 1.7;
          opacity: 0.95;
          margin-bottom: 18px;
        }

        .trix-stat-grid {
          display: grid;
          gap: 10px;
        }

        .trix-stat-item {
          background: rgba(255,255,255,0.08);
          border-radius: 12px;
          padding: 12px 14px;
        }

        .trix-stat-value {
          font-size: 1.8rem;
          font-weight: 900;
          line-height: 1.1;
        }

        .trix-stat-label {
          opacity: 0.8;
          margin-top: 4px;
        }

        .trix-section {
          margin-top: 56px;
        }

        .trix-eyebrow {
          font-size: 12px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #2563eb;
          font-weight: 900;
          margin-bottom: 10px;
        }

        .trix-section h2 {
          margin: 0 0 22px;
          font-size: clamp(2rem, 3vw, 3rem);
          line-height: 1.1;
          letter-spacing: -0.04em;
        }

        .trix-two-col,
        .trix-cards,
        .trix-metric-grid {
          display: grid;
          gap: 18px;
        }

        .trix-two-col {
          grid-template-columns: 1.2fr 0.8fr;
        }

        .trix-cards {
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        }

        .trix-metric-grid {
          grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
        }

        .trix-card {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 20px;
          padding: 22px;
          box-shadow: 0 20px 44px rgba(15, 23, 42, 0.04);
        }

        .trix-card h3 {
          margin: 0 0 12px;
          font-size: 1.1rem;
        }

        .trix-card ul {
          margin: 0;
          padding-left: 20px;
          line-height: 1.8;
          color: #334155;
        }

        .trix-check {
          width: 42px;
          height: 42px;
          border-radius: 12px;
          display: grid;
          place-items: center;
          background: #dbeafe;
          color: #1d4ed8;
          font-weight: 900;
          margin-bottom: 10px;
        }

        .trix-compare-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-top: 18px;
        }

        .trix-compare-card {
          background: white;
          border: 1px solid #dbeafe;
          border-radius: 24px;
          padding: 22px;
          box-shadow: 0 22px 48px rgba(15, 23, 42, 0.04);
        }

        .trix-compare-card--before {
          background: linear-gradient(180deg, #fffaf5 0%, #fff 100%);
          border-color: #fed7aa;
        }

        .trix-compare-card--after {
          background: linear-gradient(180deg, #f0fdf8 0%, #fff 100%);
          border-color: #bbf7d0;
        }

        .trix-compare-head {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 1.5rem;
          font-weight: 900;
          margin-bottom: 6px;
        }

        .trix-dot {
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
        }

        .trix-dot--warn {
          background: #f59e0b;
        }

        .trix-dot--ok {
          background: #10b981;
        }

        .trix-compare-subtitle {
          color: #475569;
          margin-bottom: 14px;
        }

        .trix-flow-rail {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 10px;
        }

        .trix-flow-node {
          border-radius: 12px;
          padding: 12px 10px;
          text-align: center;
          font-weight: 800;
          animation: float 4s ease-in-out infinite;
        }

        .trix-flow-node--before {
          background: #fff7ed;
          color: #9a4d00;
        }

        .trix-flow-node--after {
          background: #dcfce7;
          color: #166534;
        }

        .trix-flow-node--info {
          background: #dbeafe;
          color: #1d4ed8;
          animation-delay: 0.8s;
        }

        .trix-flow-node--alert {
          background: #fce7f3;
          color: #9d174d;
          animation-delay: 1.4s;
        }

        .trix-note {
          margin-top: 16px;
          padding: 16px;
          border-radius: 16px;
          line-height: 1.7;
          font-weight: 600;
        }

        .trix-note--warn {
          background: #fff7ed;
          color: #9a4d00;
        }

        .trix-note--ok {
          background: #ecfdf5;
          color: #166534;
        }

        .trix-module-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 18px;
        }

        .trix-module-tag {
          background: linear-gradient(135deg, #ecfeff, #dbeafe);
          color: #0f766e;
          border: 1px solid rgba(15,118,110,0.12);
          padding: 9px 12px;
          border-radius: 999px;
          font-size: 12px;
          font-weight: 800;
        }

        .trix-metric-card {
          background: white;
          border: 1px solid #e2e8f0;
          border-radius: 20px;
          padding: 22px;
          box-shadow: 0 20px 44px rgba(15, 23, 42, 0.04);
        }

        .trix-metric-card strong {
          display: block;
          font-size: 2.2rem;
          margin-bottom: 8px;
        }

        .trix-cta-box {
          background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 52%, #0ea5a4 100%);
          color: white;
          border-radius: 26px;
          padding: 34px 28px;
          margin-top: 40px;
          box-shadow: 0 25px 65px rgba(15, 23, 42, 0.18);
        }

        .trix-cta-box h3 {
          margin: 0 0 10px;
          font-size: clamp(2rem, 4vw, 3rem);
          line-height: 1.08;
          letter-spacing: -0.04em;
        }

        .trix-cta-box p {
          margin: 0 0 20px;
          font-size: 1.1rem;
          line-height: 1.8;
          color: rgba(255,255,255,0.9);
          max-width: 900px;
        }

        .trix-footer {
          text-align: center;
          margin-top: 30px;
          color: #475569;
          font-size: 14px;
          font-weight: 700;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-4px); }
        }

        @media (max-width: 900px) {
          .trix-intro-grid,
          .trix-two-col,
          .trix-compare-grid {
            grid-template-columns: 1fr;
          }

          .trix-shell {
            padding-top: 24px;
          }
        }
      `}</style>

      <div className="trix-page">
        <div className="trix-shell">
          <header className="trix-hero">
            <div className="trix-topbar">
              <div className="trix-brand">TRIX</div>
              <div className="trix-cta-row">
                <a href="/demo-venta" className="trix-btn trix-btn--secondary">Ver demo</a>
                <a href="/login" className="trix-btn trix-btn--primary">Solicitar demo</a>
              </div>
            </div>

            <div className="trix-intro-grid">
              <div>
                <div className="trix-kicker">Más control • Más velocidad • Más margen</div>
                <h1>{perfil.headline}</h1>
                <p>{perfil.descripcion}</p>

                <div className="trix-select-wrap">
                  <label className="trix-field-label">Selecciona tu tipo de negocio</label>
                  <select
                    className="trix-select"
                    value={tipo}
                    onChange={(e) => setTipo(e.target.value)}
                    aria-label="Selecciona sector comercial"
                  >
                    {tipos.map(([key, item]) => (
                      <option key={key} value={key}>{item.nombre}</option>
                    ))}
                  </select>
                </div>

                <div className="trix-hero-actions">
                  <a href="/login" className="trix-btn trix-btn--primary">Solicitar propuesta</a>
                  <a href="#sector" className="trix-btn trix-btn--secondary">Ver sector</a>
                </div>
              </div>

              <div className="trix-panel">
                <div className="trix-panel-kicker">Sector actual</div>
                <div className="trix-sector-name">{perfil.logo} {perfil.nombre}</div>
                <div className="trix-tagline">{perfil.tagline}</div>

                <div className="trix-stat-grid">
                  {perfil.metricas.map((m) => (
                    <div className="trix-stat-item" key={m.texto}>
                      <div className="trix-stat-value">{m.valor}</div>
                      <div className="trix-stat-label">{m.texto}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </header>

          <section id="sector" className="trix-section">
            <div className="trix-eyebrow">Sector</div>
            <h2>{perfil.nombre}</h2>
            <div className="trix-two-col">
              <article className="trix-card">
                <h3>El problema real</h3>
                <ul>
                  {perfil.problemas.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </article>

              <article className="trix-card">
                <h3>La solución</h3>
                <ul>
                  {perfil.soluciones.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </article>
            </div>
          </section>

          <section className="trix-section">
            <div className="trix-eyebrow">Control de stock</div>
            <h2>Alertas inteligentes para reponer antes de quedarse sin producto</h2>
            <div className="trix-two-col">
              <article className="trix-card">
                <h3>Cómo funciona</h3>
                <ul>
                  <li>Configura una cantidad mínima por producto, material o referencia.</li>
                  <li>Cuando el stock baja del umbral, Trix dispara una alerta inteligente.</li>
                  <li>La alerta se puede ver en el dashboard y enviar por Slack o notificación.</li>
                  <li>Así el responsable puede hacer el pedido antes de que falte material o inventario.</li>
                </ul>
              </article>

              <article className="trix-card">
                <h3>Beneficio directo</h3>
                <ul>
                  <li>Evita roturas de stock y paradas de producción.</li>
                  <li>Reduce compras impulsivas y faltantes críticos.</li>
                  <li>Mejora la planificación de compras y aprovisionamiento.</li>
                  <li>Da visibilidad real del inventario y de los productos que necesitan pedido.</li>
                </ul>
              </article>
            </div>

            <div className="trix-compare-grid" style={{ marginTop: 20 }}>
              <div className="trix-compare-card trix-compare-card--before">
                <div className="trix-compare-head">
                  <span className="trix-dot trix-dot--warn"></span>
                  Sin Trix
                </div>
                <div className="trix-compare-subtitle">Stock bajo sin avisar.</div>
                <div className="trix-flow-rail">
                  <div className="trix-flow-node trix-flow-node--before">Revisión tardía</div>
                  <div className="trix-flow-node trix-flow-node--before">Falta de producto</div>
                  <div className="trix-flow-node trix-flow-node--before">Pedido urgente</div>
                </div>
                <div className="trix-note trix-note--warn">
                  El negocio descubre el problema demasiado tarde, con coste, retrasos y pérdida de servicio.
                </div>
              </div>

              <div className="trix-compare-card trix-compare-card--after">
                <div className="trix-compare-head">
                  <span className="trix-dot trix-dot--ok"></span>
                  Con Trix
                </div>
                <div className="trix-compare-subtitle">Pedido anticipado y sin pérdidas.</div>
                <div className="trix-flow-rail">
                  <div className="trix-flow-node trix-flow-node--after">Control mínimo</div>
                  <div className="trix-flow-node trix-flow-node--info">Alerta automatica</div>
                  <div className="trix-flow-node trix-flow-node--alert">Pedido a tiempo</div>
                </div>
                <div className="trix-note trix-note--ok">
                  El equipo actúa antes de que el faltante afecte a clientes, producción o rentabilidad.
                </div>
              </div>
            </div>
          </section>

          <section className="trix-section">
            <div className="trix-eyebrow">Antes y después</div>
            <h2>Todo en una sola operación</h2>
            <div className="trix-compare-grid">
              <div className="trix-compare-card trix-compare-card--before">
                <div className="trix-compare-head">
                  <span className="trix-dot trix-dot--warn"></span>
                  Antes
                </div>
                <div className="trix-compare-subtitle">La operación está fragmentada.</div>
                <div className="trix-flow-rail">
                  <div className="trix-flow-node trix-flow-node--before">WhatsApp</div>
                  <div className="trix-flow-node trix-flow-node--before">Excel</div>
                  <div className="trix-flow-node trix-flow-node--before">Llamadas</div>
                </div>
                <div className="trix-note trix-note--warn">
                  Pérdida de tiempo, duplicación de información y falta de visión real del negocio.
                </div>
              </div>

              <div className="trix-compare-card trix-compare-card--after">
                <div className="trix-compare-head">
                  <span className="trix-dot trix-dot--ok"></span>
                  Ahora con Trix
                </div>
                <div className="trix-compare-subtitle">Todo centralizado y controlado.</div>
                <div className="trix-flow-rail">
                  <div className="trix-flow-node trix-flow-node--after">Clientes</div>
                  <div className="trix-flow-node trix-flow-node--info">Operación</div>
                  <div className="trix-flow-node trix-flow-node--alert">Alertas</div>
                </div>
                <div className="trix-note trix-note--ok">
                  Menos caos, mejor servicio, mejor control y más capacidad de crecimiento.
                </div>
              </div>
            </div>
          </section>

          <section className="trix-section">
            <div className="trix-eyebrow">Ventaja comercial</div>
            <h2>Qué ofrece Trix y por qué importa</h2>
            <div className="trix-cards">
              {perfil.beneficios.map((beneficio, index) => (
                <article key={beneficio} className="trix-card">
                  <div className="trix-check">{index + 1}</div>
                  <div style={{ fontSize: '1.02rem', lineHeight: 1.7, color: '#334155' }}>{beneficio}</div>
                </article>
              ))}
            </div>
          </section>

          <section className="trix-section">
            <div className="trix-eyebrow">Módulos clave</div>
            <h2>Lo que puede activar y adaptar al negocio</h2>
            <div className="trix-module-list">
              {perfil.modulos.map((modulo) => (
                <span key={modulo} className="trix-module-tag">{modulo}</span>
              ))}
            </div>
          </section>

          <section className="trix-section">
            <div className="trix-eyebrow">Nuestra propuesta</div>
            <h2>Más control, menos tiempo perdido y mejor rentabilidad</h2>
            <div className="trix-metric-grid">
              {perfil.metricas.map((metric) => (
                <div key={metric.texto} className="trix-metric-card">
                  <strong>{metric.valor}</strong>
                  <div style={{ color: '#475569' }}>{metric.texto}</div>
                </div>
              ))}
            </div>
          </section>

          <section className="trix-cta-box">
            <div style={{ fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', opacity: 0.8, marginBottom: 8 }}>CTA comercial</div>
            <h3>¿Quieres que tu negocio funcione mejor, no más complicado?</h3>
            <p>
              Trix ayuda a que cada empresa gestione clientes, operación, documentos y equipo desde un único sistema,
              con visibilidad real y control remoto. Menos caos, menos pérdida de tiempo y más capacidad de crecimiento.
            </p>
            <div className="trix-cta-row">
              <a href="/login" className="trix-btn trix-btn--primary">Solicitar demo</a>
              <a href="/demo-venta" className="trix-btn trix-btn--secondary">Ver demo rápida</a>
            </div>
          </section>

          <div className="trix-footer">Trix • Gestiona tu negocio sin perder el control.</div>
        </div>
      </div>
    </>
  );
}
